import type { AnalysisReport, RepairResult } from '../core/types';

export function analysisReportJson(report: AnalysisReport): string {
  return JSON.stringify(report, null, 2);
}

export function analysisReportText(report: AnalysisReport): string {
  return [
    'MENDBYTE RECOVERY REPORT',
    `Engine: ${report.engineVersion} / ruleset ${report.rulesetVersion}`,
    `File: ${reportTextValue(report.file.name)}`,
    `Format: ${reportTextValue(report.detected.format)}`,
    `Size: ${report.file.size} bytes`,
    `SHA-256: ${report.file.sha256}`,
    `Processed: ${report.completedAt}`,
    `File Health: ${report.health.overall}/100 (${report.health.model})`,
    '',
    'ISSUES',
    ...(report.issues.length
      ? report.issues.map((issue) => `[${issue.severity.toUpperCase()}] ${reportTextValue(issue.title)} — ${reportTextValue(issue.component)}\n${reportTextValue(issue.detail)}\nEvidence: ${reportTextValue(issue.evidence)}`)
      : ['No structural issues detected within the implemented checks.']),
    '',
    'REPAIR PLAN',
    ...(report.repairPlan.length
      ? report.repairPlan.map((item) => `${item.order}. ${reportTextValue(item.title)} (${reportTextValue(item.rule.id)} ${reportTextValue(item.rule.version)})\n${reportTextValue(item.detail)}`)
      : ['No implemented safe repair rule applies.']),
    '',
    'LIMITATIONS',
    ...report.limitations.map((limitation) => `- ${reportTextValue(limitation)}`),
  ].join('\n');
}

export function reportTextValue(value: string): string {
  let result = '';
  for (const character of value) {
    const codePoint = character.codePointAt(0) ?? 0;
    const unsafe = codePoint <= 0x1f
      || (codePoint >= 0x7f && codePoint <= 0x9f)
      || codePoint === 0x2028
      || codePoint === 0x2029
      || (codePoint >= 0x202a && codePoint <= 0x202e)
      || (codePoint >= 0x2066 && codePoint <= 0x2069)
      || codePoint === 0xfeff;
    result += unsafe ? `\\u{${codePoint.toString(16).toUpperCase().padStart(4, '0')}}` : character;
  }
  return result;
}

export function repairReportJson(result: RepairResult): string {
  return JSON.stringify(
    {
      outcome: result.outcome,
      original: result.original,
      validatedOutput: result.validated,
      actions: result.actions,
      comparison: result.comparison,
    },
    null,
    2,
  );
}
